module.exports = __webpack_public_path__ + "static/media/terravax_300ph.23e47e35.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/agave/climasense/fusarium_agave/curativa/terravax_300ph.png
// module id = 1032
// module chunks = 3